import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { reportTextTemplateKeys } from './reportTextTemplates.key';

export function useGetReportTextTemplates() {
  const getApi = useApi();

  const getTemplates = async () => {
    const api = await getApi();
    const res = await api.reportTextTemplatesFindAll();
    return res.data;
  };

  return useQuery({
    queryKey: reportTextTemplateKeys.findMany(),
    queryFn: getTemplates,
  });
}
